export const DATE_FORMATS = {
  // for date pipe
  SHORT: 'dd.MM.yyyy HH:mm',
  MEDIUM: 'd. MMM yyyy H:mm',
  LONG: 'd. MMMM yyyy H:mm',
  FULL: 'EEEE, d. MMMM yyyy H:mm',
  ISO: 'yyyy-MM-ddTHH:mm:ss',
  DATE_TIME: 'dd.MM.yyyy HH:mm:ss',
  DAY_LONG_DATE_SHORT: 'EEEE, dd.MM.yyyy',
  DATE_SHORT: 'dd.MM.yyyy',
  DATE_MEDIUM: 'd. MMM yyyy',
  DATE_LONG: 'd. MMMM yyyy',
  DATE_FULL: 'EEEE, d. MMMM yyyy',
  DATE_ISO: 'yyyy-MM-dd',
  TIME_SHORT: 'HH:mm',
  TIME_MEDIUM: 'H:mm',
  TIME_LONG: 'H:mm:ss z',
  TIME_FULL: 'H:mm:ss zzzz',
  // for PrimeNG calendar component
  CALENDAR_DATE_SHORT: 'dd.mm.yy',
  CALENDAR_MONTH_SHORT: 'mm.yy',
  CALENDAR_YEAR_SHORT: 'yy',
} as const
